import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { ActionCreator } from '@ngrx/store/src/models';
import { Observable, filter, map, withLatestFrom } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { BetslipPlaceBetActions, FinishPlaceBetPayload } from '../../betplacement/actions';
import { isSucceededNonPartialSlip } from '../../betplacement/utils';
import { QuickBetActions } from '../../quick-bet/quick-bet-actions';
import { HiddenMarketActions } from '../hidden-market.actions';
import { hasPlacedFirstBetSelector } from '../hidden-market.selectors';

@Injectable()
export class HiddenMarketEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
    ) {}

    handleFinishPlaceBet$ = createEffect(() => {
        return this.createObservable(BetslipPlaceBetActions.finishPlaceBet);
    });

    handleFinishPlaceBetQuickbet$ = createEffect(() => {
        return this.createObservable(QuickBetActions.finishPlaceBet);
    });

    private createObservable(
        sourceType: ActionCreator<string, (props: FinishPlaceBetPayload) => FinishPlaceBetPayload & Action<string>>,
    ): Observable<Action<string>> {
        return this.actions$.pipe(
            ofType(sourceType),
            withLatestFrom(this.store.select(hasPlacedFirstBetSelector)),
            filter(([action, hasPlacedFirstBet]) => {
                const verifyNewCustomerOfferPlaced = () =>
                    action.placeBetResult.slips.some(
                        (x) => isSucceededNonPartialSlip(x) && x.picks.some((y) => y.clientPick?.isNewCustomerOfferPick),
                    );

                return !hasPlacedFirstBet && verifyNewCustomerOfferPlaced();
            }),
            map((_) => HiddenMarketActions.setHasPlacedFirstBet()),
        );
    }
}
